import React from 'react'
import {useTranslation} from 'react-i18next'
import {Tabs} from 'antd'
import {useNavigate, useParams} from 'react-router-dom'
import {observer} from 'mobx-react'
import classNames from 'classnames'

import {getPaymentMethodTypeLabel, PaymentMethodType} from '@/constants'
import {useScreenType} from '@/hooks'
import {ROUTES} from '@/router/routes'
import {getPaymentMethodDetailsRoute, withTitle} from '@/router/utils'
import {
    ApplePayPaymentMethod,
    PaypalPaymentMethod,
    GooglePayPaymentMethod,
    KlarnaPaymentMethod
} from '@/pages/payment-methods'
import {BackButton} from '@/components'

import styles from './styles.scss'
import {paymentMethodTabs} from '@/constants/payment-method-info'

const TabbedPaymentMethods: React.FC<object> = observer(() => {
    const {t} = useTranslation()
    const {isMobile, isDesktop} = useScreenType()
    const {type} = useParams()
    const navigate = useNavigate()

    const setPaymentType = (activeKey) => {
        navigate(getPaymentMethodDetailsRoute(activeKey))
    }

    const renderMobilePaymentMethod = () => {
        switch (type) {
            case PaymentMethodType.klarna:
                return <KlarnaPaymentMethod />
            case PaymentMethodType.applepay:
                return <ApplePayPaymentMethod />
            case PaymentMethodType.paypal:
                return <PaypalPaymentMethod />
            case PaymentMethodType.googlepay:
                return <GooglePayPaymentMethod />
            default:
                return null
        }
    }

    const renderPaymentMethod = (type: PaymentMethodType) => {
        switch (type) {
            case PaymentMethodType.applepay:
                return <ApplePayPaymentMethod />
            case PaymentMethodType.googlepay:
                return <GooglePayPaymentMethod />
            case PaymentMethodType.paypal:
                return <PaypalPaymentMethod />
            case PaymentMethodType.klarna:
                return <KlarnaPaymentMethod />
            default:
                return null
        }
    }

    return (
        <>
            <br />
            <br />
            <BackButton
                className={styles.link}
                to={ROUTES.settings.paymentMethods}
                title={t('TabbedPaymentMethods.allPaymentMethods')}
            />
            {!isMobile ? (
                <Tabs
                    activeKey={type}
                    onChange={setPaymentType}
                    className={classNames(styles.tabs, {[styles.tabsDesktop]: isDesktop})}
                    tabPosition={'right'}
                >
                    {paymentMethodTabs.map((tab) => (
                        <Tabs.TabPane
                            key={tab.key}
                            tab={getPaymentMethodTypeLabel(tab.key)}
                            className={styles.tabPane}
                        >
                            {renderPaymentMethod(tab.key)}
                        </Tabs.TabPane>
                    ))}
                </Tabs>
            ) : null}
            {isMobile ? renderMobilePaymentMethod() : null}
        </>
    )
})

export default withTitle(TabbedPaymentMethods)
